import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from 'environments/environment';
import { VinculoFuncionalDto } from "../dtos/vinculo-funcional.dto";
import { VinculoMediaDto } from "../dtos/vinculo-media.dto";
import { DataUtil } from "../utils/data.util";

@Injectable({
  providedIn: 'root'
})
export class SgprevPensaoService {
  static buscarDadosRelarorioMedia(matricula: string, orgaoOrigem: string) {
    throw new Error('Method not implemented.');
  }
  private apiUrl = `${environment.API_URL}/integracao-seplag`;

  constructor(private http: HttpClient) { }

  public buscarDadosCalculo(isnOrgao: string, matricula: string, dataObito: Date, recalculo: boolean): Observable<any> {
    const dataFormatada = this.getDataFormatada(dataObito)

    if (recalculo)
      return this.http.get<any>(`${this.apiUrl}/pensao/recalculo/orgao/${isnOrgao}/matricula/${matricula}/dataObito/${dataFormatada}`);
    else
      return this.http.get<any>(`${this.apiUrl}/pensao/orgao/${isnOrgao}/matricula/${matricula}/dataObito/${dataFormatada}`);
  }

  public salvarBeneficioMedio(isnOrgao: string, matricula: string, dadosBeneficio: any) {
    return this.http.post<any>(`${this.apiUrl}/pensao/salvar-beneficio-medio?orgaoId=${isnOrgao}&matricula=${matricula}`, dadosBeneficio);
  }

  public incluirMatriculasMedia(isnOrgao: string, matricula: string, vinculosMediaDto: VinculoMediaDto[]) {
    return this.http.post<any>(`${this.apiUrl}/pensao/incluir-matriculas-na-media?orgaoId=${isnOrgao}&matricula=${matricula}`, vinculosMediaDto);

  }

  public buscarDescricaoMedia(isnOrgao: string, matricula: string) {
    return this.http.get(`${this.apiUrl}/regra/campo-media-regra?orgaoId=${isnOrgao}&matricula=${matricula}`, { responseType: 'text' });
  }

  public buscarDadosRelarorioMedia(isnOrgao: string, matricula: string, dataObito: Date | string) {
    return this.http.get<any>(`${this.apiUrl}/relatorio-pensao/orgao/${isnOrgao}/matricula/${matricula}/dataObito/${this.formatarData(dataObito)}`
    );
  }
  
  public buscarVinculosFuncionais(isnOrgao: string, matricula: string) {
    return this.http.get<VinculoFuncionalDto[]>(`${this.apiUrl}/vinculo/matriculas-validas-para-incluir-na-media/matricula/${matricula}/orgao/${isnOrgao}`);
  }

  formatarData(data: Date | string): string {
    const dataObj = typeof data === "string" ? DataUtil.newDateOnly(data) : data;
    if (isNaN(dataObj.getTime())) {
      return "";
    }
    const ano = dataObj.getFullYear();
    const mes = String(dataObj.getMonth() + 1).padStart(2, "0");
    const dia = String(dataObj.getDate()).padStart(2, "0");
    return `${ano}-${mes}-${dia}`;
  }
  

  private getDataFormatada(data: Date) {
    let mm = data.getMonth() + 1;
    let dd = data.getDate();

    let ddfStr = '' + dd;
    let mmStr = '' + mm;

    if (dd < 10)
      ddfStr = '0' + dd;

    if (mm < 10)
      mmStr = '0' + mm;

    return data.getFullYear() + '-' + mmStr + '-' + ddfStr;
  }
}
